var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTipsOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93213 7.32918C7.93213 5.07402 9.7603 3.24585 12.0155 3.24585H36.5155C37.0116 3.24585 37.4844 3.45641 37.8162 3.82516L48.3162 15.4918C48.6054 15.8132 48.7655 16.2302 48.7655 16.6625V27.1625C48.7655 28.129 47.982 28.9125 47.0155 28.9125C46.049 28.9125 45.2655 28.129 45.2655 27.1625V17.3341L35.7361 6.74585H12.0155C11.6933 6.74585 11.4321 7.00702 11.4321 7.32918V49.3292C11.4321 49.6514 11.6933 49.9125 12.0155 49.9125H26.0155C26.982 49.9125 27.7655 50.696 27.7655 51.6625C27.7655 52.629 26.982 53.4125 26.0155 53.4125H12.0155C9.76032 53.4125 7.93213 51.5844 7.93213 49.3292V7.32918Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8488 28.9125C39.8153 28.9125 40.5988 29.696 40.5988 30.6625V42.3292C40.5988 43.2957 39.8153 44.0792 38.8488 44.0792C37.8823 44.0792 37.0988 43.2957 37.0988 42.3292V30.6625C37.0988 29.696 37.8823 28.9125 38.8488 28.9125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8488 53.9959C40.4596 53.9959 41.7655 52.69 41.7655 51.0792C41.7655 49.4684 40.4596 48.1625 38.8488 48.1625C37.238 48.1625 35.9321 49.4684 35.9321 51.0792C35.9321 52.69 37.238 53.9959 38.8488 53.9959Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3488 3.24585C36.3153 3.24585 37.0988 4.02935 37.0988 4.99585V14.9125H47.0155C47.982 14.9125 48.7655 15.696 48.7655 16.6625C48.7655 17.629 47.982 18.4125 47.0155 18.4125H35.3488C34.3823 18.4125 33.5988 17.629 33.5988 16.6625V4.99585C33.5988 4.02935 34.3823 3.24585 35.3488 3.24585Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTipsOne);
export default __webpack_public_path__ + "static/media/file-tips-one.6cc25f93.svg";
export { ForwardRef as ReactComponent };